import { render, staticRenderFns } from "./upload-metadata.vue?vue&type=template&id=4ec25456&scoped=true&"
import script from "./upload-metadata.vue?vue&type=script&lang=js&"
export * from "./upload-metadata.vue?vue&type=script&lang=js&"
import style0 from "./upload-metadata.vue?vue&type=style&index=0&id=4ec25456&scoped=true&lang=css&"
import style1 from "./upload-metadata.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec25456",
  null
  
)

export default component.exports